<div class="header">
  <div class="header-cont tables">
    <h2>{{ 'admin_poi.title' | translate }}</h2>
    <button mat-raised-button class="page-header-btns add-element" [routerLink]="['/lista-poi/nuovo-poi']">
      <mat-icon>add_location</mat-icon>
    </button>
  </div>
</div>

<div class="single-section">
  <div class="section-cont tables">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'admin_poi.search_label' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon *ngIf="!loadingPoi; else loadingList" matSuffix>search</mat-icon>
      <ng-template #loadingList>
        <mat-progress-spinner
            matSuffix
            color="primary"
            mode="indeterminate"
            [diameter]="24">
        </mat-progress-spinner>
      </ng-template>
    </mat-form-field>
  </div>
</div>

<div class="admin-table">
  <table mat-table [dataSource]="dataSource">

    <!-- POI name Column -->
    <ng-container matColumnDef="poi_name">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_poi.columns.poi' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{row.poi_name[current_lang]}}
      </td>
    </ng-container>

    <!-- Address Column -->
    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_poi.columns.address' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{row.address}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [routerLink]="['/lista-poi/'+row.id]">
    </tr>
  </table>

  <mat-paginator class="mat-paginator-sticky" [length]="poi_list_total" [pageSize]="poi_list_size"></mat-paginator>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
